import React from "react";

function RetiradaReforco({ reportData }) {
  const totalRetirada = reportData
    .filter((row) => row.TIPO === "R")
    .reduce((sum, row) => sum + row.VALOR, 0);

  const totalReforco = reportData
    .filter((row) => row.TIPO !== "R")
    .reduce((sum, row) => sum + row.VALOR, 0);

  return (
    <table className="min-w-full bg-white border border-solid border-gray-300">
      <thead className="bg-gray-300">
        <tr>
          <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] w-[50%]">
            Data/Hora
          </th>
          <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] w-[50%]">
            Descrição
          </th>
          <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] w-[50%]">
            Tipo
          </th>
          <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] w-[50%]">
            PDV
          </th>
          <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] w-[50%]">
            Turno
          </th>
          <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] w-[50%]">
            Valor
          </th>
        </tr>
      </thead>
      <tbody>
        {reportData.map((row, index) => (
          <tr key={index} className="hover:bg-gray-200">
            <td className="font-Roboto px-4 py-2 border-b text-sm">
              {new Intl.DateTimeFormat("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              }).format(new Date(row.DATAHORA))}
            </td>
            <td className="font-Roboto px-4 py-2 border-b text-sm">
              {row.DESCRICAO}
            </td>
            <td className="font-Roboto px-4 py-2 border-b text-sm">
              {row.TIPO === "R" ? "Retirada" : "Reforço"}
            </td>
            <td className="font-Roboto px-4 py-2 border-b text-sm">
              {row.CODPDV}
            </td>
            <td className="font-Roboto px-4 py-2 border-b text-sm">
              {row.TURNO}
            </td>
            <td className="font-Roboto px-4 py-2 border-b text-sm">
              {new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(row.VALOR)}
            </td>
          </tr>
        ))}

        <tr className="bg-gray-100 font-[600]">
          <td colSpan="5" className="px-4 py-2 text-sm text-right">
            Total Retirada:
          </td>
          <td className="px-4 py-2 text-sm text-left">
            {new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(totalRetirada)}
          </td>
        </tr>
        <tr className="bg-gray-100 font-[600]">
          <td colSpan="5" className="px-4 py-2 text-sm text-right">
            Total Reforço:
          </td>
          <td className="px-4 py-2 text-sm text-left">
            {new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(totalReforco)}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default RetiradaReforco;
